import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Storage Area
      {record ? `: ${record.name}` : ''}
    </span>
  );
};
